import {
    IBookingSearchCommonFields,
    IBookingSearchCommonPersistedFields
} from "../common/booking-search-common-fields.interface";
import {StandardBookingSearchStrategy} from "../common/standard-booking-search.strategy";
import {BookingSearchStrategyType} from "../booking-search.strategy.interface";
import {FormFields} from "../../../../models/forms/form-field.interface";
import {
    IBookingSearchByPhoneNumberRequest,
    IBookingSearchPagination
} from "../../../airline-webapi/requests/booking-search.requests";
import {IBookingSearchResultRecord} from "../../../airline-webapi/responses/booking-search.response";
import React from "react";
import {SearchByPhoneNumberComponent} from "./search-by-phone-number.component";
import {NullableString} from "../../../../types/nullable-types";
import {callOutline} from "ionicons/icons";

interface ISearchByPhoneNumberFields extends IBookingSearchCommonFields {
    phoneNumber: string;
}

interface ISearchByPhoneNumberPersistedFields extends IBookingSearchCommonPersistedFields {
    phoneNumber: string;
}



export class SearchByPhoneNumberStrategy extends StandardBookingSearchStrategy<ISearchByPhoneNumberFields, ISearchByPhoneNumberPersistedFields> {

    get type(): BookingSearchStrategyType {
        return BookingSearchStrategyType.ByPhoneNumber;
    }

    get name(): string {
        return this.services.language.translate("By phone number");
    }

    get resultsDescription(): string {
        return this.services.language.translate("Results by phone number");
    }

    protected _getIonIconName(): NullableString {
        return callOutline;
    }

    protected _createFilterFields(persistedFields: ISearchByPhoneNumberPersistedFields): FormFields<ISearchByPhoneNumberFields> {
        return {
            phoneNumber: this._createField<string>({
                fieldName: () => this.services.language.translate("Phone number"),
                isRequired: true,
                defaultValue: persistedFields?.phoneNumber ?? null,
            }),
            ...this._createCommonFields(persistedFields)
        };
    }

    renderSearchFields(): React.ReactElement {
        return <SearchByPhoneNumberComponent strategy={this} />;
    }

    async _searchBookings(sessionToken: string, pagination: IBookingSearchPagination): Promise<IBookingSearchResultRecord[]> {
        const request: IBookingSearchByPhoneNumberRequest = {
            dotRezToken: sessionToken,
            phoneNumber: this.fields.phoneNumber.value!,
            filters: this._createCommonFilters(pagination)
        };

        const response = await this.services.airlineWebapi.agencyBookingSearchByPhoneNumber(request);
        return response.results;
    }

    protected _collectFieldsValuesForStorage(): ISearchByPhoneNumberPersistedFields {
        return {
            phoneNumber: this.fields.phoneNumber.value ?? "",
            ...this._collectCommonFieldsValuesForStorage()
        };
    }
}
